/* ============================================================
   WFR CUSTOM SCRIPTS
   Aus theme.liquid ausgelagert. Wird via
   <script src="wfr-custom.js" defer></script> eingebunden.
   Bei Dawn-Updates NICHT ueberschrieben (eigene Datei).

   Zweck: Tidio-Chat-Widget ausblenden, solange der
   Warenkorb-Drawer geoeffnet ist.
   ============================================================ */

(function () {
        let tidioHiddenStyle = null;
        let tidioObserverStarted = false;

        function hideTidio() {
          if (!window.tidioChatApi || tidioHiddenStyle) return;
          tidioHiddenStyle = window.tidioChatApi.adjustStyles('#tidio { display: none !important; }');
        }

        function showTidio() {
          if (!window.tidioChatApi || !tidioHiddenStyle) return;
          window.tidioChatApi.removeStyles(tidioHiddenStyle);
          tidioHiddenStyle = null;
        }

        function isCartDrawerOpen() {
          const cartDrawer = document.getElementById('CartDrawer');
          const activeDrawer = document.querySelector('cart-drawer.drawer.active');
          const bodyHidden = document.body.classList.contains('overflow-hidden');

          return (
            (cartDrawer && cartDrawer.getAttribute('aria-hidden') === 'false') ||
            activeDrawer ||
            bodyHidden
          );
        }

        function updateTidioVisibility() {
          if (isCartDrawerOpen()) {
            hideTidio();
          } else {
            showTidio();
          }
        }

        function startTidioCartWatcher() {
          if (tidioObserverStarted) return;
          tidioObserverStarted = true;

          updateTidioVisibility();

          const observer = new MutationObserver(() => {
            updateTidioVisibility();
          });

          observer.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['class', 'aria-hidden']
          });
        }

        function onTidioReady() {
          startTidioCartWatcher();
        }

        if (window.tidioChatApi) {
          window.tidioChatApi.on('ready', onTidioReady);
        } else {
          document.addEventListener('tidioChat-ready', onTidioReady);
        }

        document.addEventListener('DOMContentLoaded', function () {
          startTidioCartWatcher();
        });
})();
